// intro-app/account/login.js

(function () {
    'use strict';
    var controllerId = 'login';
    angular.module('intro-app').controller(controllerId, ['datacontext', 'common', 'bootstrap.dialog', '$uibModal', '$translate', loginFn]);

    function loginFn(datacontext, common, bDialog, $uibModal, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.error = null;
        vm.item = {};  
        vm.login = login;
        vm.addSegnalazione = addSegnalazione;
        vm.monitoraSegnalazione = monitoraSegnalazione;

        vm.currentLanguage = $translate.use() || $translate.proposedLanguage();

        $translate.use(vm.currentLanguage);

        if (vm.lingua == 'undefined' || !vm.lingua) {
            vm.lingua = vm.currentLanguage;
        }

        vm.setLanguage = setLanguage;


        function setLanguage(language) {
            vm.lingua = language;
            $translate.use(vm.lingua);
        }

        function login() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/intro-app/account/modal/loginModal.html?version=4',
                controller: 'loginModal',
            });

            //modalInstance.result.then(function (returnItem) {
            //    if (!returnItem) return logError('Errore durante l\'inserimento del dato ');

            //    logSuccess('Segnalazione aggiunta con successo ');
            //    cerca();
            //});
        }

        //function login() {
        //    vm.error = null;

        //    return datacontext.account_login(vm.item).then(function (response) {
        //        if (response.status == 200) {
        //            window.location = "/home/index";
        //        }
        //        else {
        //            vm.item.Password = "";
        //            if (response.status == 403) { // Cambio password obbligatorio                        
        //                var username = response.data.Username;
        //                var uid = response.data.Uid;
        //                window.location = "/index/newPassword?Username=" + username + "&Uid=" + uid;
        //            }
        //            else 
        //                vm.error = response.data;
        //        }
        //    });
        //}

        //function resendMail() {
        //    vm.error = null;
        //    var obj = {};
        //    obj.Username = vm.item.Username;
        //    obj.UID = "";

        //    return datacontext.account_resendMail(obj).then(function (response) {
        //        if (response.status == 200) {
        //            vm.resendSuccess = true;
        //        }
        //        else {
        //            vm.error = response.data;
        //        }
        //    });
        //}

        function addSegnalazione() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/intro-app/segnalazione/modal/segnalazioneAdd.html?version=4',
                controller: 'segnalazioneAdd',
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ErroreInserimento'));

                logSuccess($translate.instant('SegnalazioneAggiunta'));
                cerca();
            });
        }

        function monitoraSegnalazione() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/intro-app/segnalazione/modal/segnalazioneMonitora.html?version=4',
                controller: 'segnalazioneMonitora',
                windowClass: 'modal-wide'
            });
        }
    }
})();